module.exports = __webpack_public_path__ + "c064b5a2138c00ea1722518c664c636e.svg";